module.exports = __webpack_public_path__ + "static/media/new-note-button.68d504fc.svg";